var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9928 5.50784L4.49949 9.30201L7.99532 11.3253L11.0778 8.24201C11.2342 8.08575 11.4462 7.99801 11.6673 7.99809C11.8883 7.99817 12.1003 8.08606 12.2566 8.24242C12.4128 8.39879 12.5006 8.61083 12.5005 8.83188C12.5004 9.05294 12.4125 9.26492 12.2562 9.42117L9.17282 12.5045L11.1978 15.9995L14.9928 5.50784ZM15.262 3.63784C16.2578 3.27701 17.2228 4.24201 16.862 5.23784L12.4603 17.4087C12.0987 18.407 10.7353 18.5287 10.2028 17.6095L7.52199 12.9778L2.89032 10.297C1.97115 9.76451 2.09282 8.40117 3.09115 8.03951L15.262 3.63784Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareGreenIcon);
export default __webpack_public_path__ + "static/media/share-green-icon.be7e513258ff81422d92f37ce7c60520.svg";
export { ForwardRef as ReactComponent };